import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import { Link } from "react-router-dom"

import FaIcon from "@fortawesome/react-fontawesome"

const Position = ({ path, icon, title, description, variant }) => (
  <Link
    to={path}
    className={cx(styles.link, {
      [styles.light]: variant === "light",
      [styles.gray]: variant === "gray",
    })}
  >
    <div
      className={cx(styles.container, {
        [styles.light]: variant === "light",
        [styles.gray]: variant === "gray",
      })}
    >
      <FaIcon icon={icon} className={styles.icon} />
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </div>
  </Link>
)

Position.defaultProps = {
  variant: "dark",
}

export default Position



// WEBPACK FOOTER //
// ./src/components/AvailablePositions/Position/index.jsx